import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileBookButton from "@/components/MobileBookButton";
import Home from "@/pages/Home";
import TheSocialBar from "@/pages/TheSocialBar";
import TheSocialSet from "@/pages/TheSocialSet";
import Nightclub from "@/pages/Nightclub";
import TheSocialSupply from "@/pages/TheSocialSupply";
import Events from "@/pages/Events";
import About from "@/pages/About";
import Book from "@/pages/Book";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import GiftCards from "@/pages/GiftCards";
import BuildYourExperience from "@/pages/BuildYourExperience";
import CocktailVote from "@/pages/CocktailVote";
import CheckAvailability from "@/pages/CheckAvailability";
import MyBooking from "@/pages/MyBooking";
import EventPromoModal from "@/components/EventPromoModal";
import { Toaster } from "sonner";

const ROUTE_TITLES = {
  "/": "Simply Social — Effortless Events, Memorable Moments",
  "/the-social-bar": "The Social Bar — Simply Social",
  "/the-social-set": "The Social Set — Simply Social",
  "/nightclub-rentals": "The Social Nightclub — Simply Social",
  "/the-social-supply": "The Social Supply — Simply Social",
  "/events": "Events — Simply Social",
  "/about": "About — Simply Social",
  "/book": "Book Your Event — Simply Social",
  "/build": "Build Your Experience — Simply Social",
  "/gift-cards": "Gift Cards — Simply Social",
  "/admin": "Admin — Simply Social",
  "/payment/success": "Payment Confirmed — Simply Social",
  "/payment/cancel": "Payment Cancelled — Simply Social",
  "/vote-cocktails": "Vote For Your Cocktails — Simply Social",
};

function RouteTitle() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    const title = ROUTE_TITLES[path] || ROUTE_TITLES[Object.keys(ROUTE_TITLES).find((k) => k !== "/" && path.startsWith(k))] || "Simply Social";
    document.title = title;
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <RouteTitle />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/the-social-bar" element={<TheSocialBar />} />
          <Route path="/the-social-set" element={<TheSocialSet />} />
          <Route path="/nightclub-rentals" element={<Nightclub />} />
          <Route path="/the-social-supply" element={<TheSocialSupply />} />
          <Route path="/events" element={<Events />} />
          <Route path="/availability" element={<CheckAvailability />} />
          <Route path="/gallery" element={<Navigate to="/" replace />} />
          <Route path="/vote-cocktails/:session_id" element={<CocktailVote />} />
          <Route path="/about" element={<About />} />
          <Route path="/book" element={<Book />} />
          <Route path="/my-booking" element={<MyBooking />} />
          <Route path="/my-booking/:token" element={<MyBooking />} />
          <Route path="/build" element={<BuildYourExperience />} />
          <Route path="/gift-cards" element={<GiftCards />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
        <Footer />
        <MobileBookButton />
        <EventPromoModal />
        <Toaster theme="dark" position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
